"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styling_1 = require("../../styling");
const utils_1 = require("../../styling/utils");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const Close_1 = tslib_1.__importDefault(require("../Buttons/Close"));
const AlertBase = ({ children, classes = {}, active, setActive, ...props }) => {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: styles_1.default }, "alertBase");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, styles_1.default);
    return (react_1.default.createElement("div", { className: `${mergedClasses.root} ${active && "open"}`, ...props },
        react_1.default.createElement("div", { className: mergedClasses.inner }, children),
        react_1.default.createElement(Close_1.default, { onClick: () => setActive(false), open: active, classes: { root: mergedStyles.closeButton } })));
};
exports.default = AlertBase;
//# sourceMappingURL=AlertBase.js.map